<!-- 部门管理 -->
<template>
  <div>
    <div class="s_wrapper">
      <el-input class="s_input" suffix-icon="el-icon-search" v-model="departmentName" placeholder="搜索部门名称" @change="onScreenData" clearable></el-input>
      <el-button type="primary" @click="handleAdd">新增部门</el-button>
    </div>
    <!-- 表格 -->
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" row-key="departmentId" :tree-props="{children: 'childDepartmentInfoVos'}" max-height="540" v-loading="dataLoding">
        <el-table-column show-overflow-tooltip prop="departmentName" label="部门名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="departmentHead" label="部门负责人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="departmentType" label="项目类型">
          <template slot-scope="scope">
            <div v-if="scope.row.departmentType==1">项目服务部门</div>
            <div v-else-if="scope.row.departmentType==2">职能部门</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.parentId == 0" type="primary" plain @click="handleAddTwo(scope.row)">新增</el-button>
            <!-- <el-button v-if="scope.row.parentCategoryId > 0" type="primary" plain @click="handleUpdateProduct(scope.row)">添加商品</el-button> -->
            <el-button @click="handleEdit(scope.row)">修改</el-button>
            <el-button type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination> -->

    <!-- 申请分类弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" @close="handleCloseDialog">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo_ruleForm">
        <el-row>
          <el-col :span="11">
            <el-form-item label="部门名称" prop="departmentName">
              <el-input v-model="ruleForm.departmentName" placeholder="请输入部门名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="部门负责人" prop="departmentHead">
              <el-input v-model="ruleForm.departmentHead" placeholder="请输入部门负责人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="项目类型" prop="departmentType">
              <el-select v-model="ruleForm.departmentType" placeholder="请选择项目类型" :disabled="twoEdit">
                <el-option v-for="item in arry" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11" v-if="twoEdit">
            <el-form-item label="上级部门" prop="departmentId">
              <el-select v-model="ruleForm.departmentId" placeholder="请选择" :disabled="twoEdit">
                <el-option v-for="item in options" :key="item.departmentId" :label="item.departmentName" :value="item.departmentId">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

function createRuleForm() {
  return {
    parentId: "", // 
    parentCategoryId: "",
    departmentName: "",
    departmentHead: "",
    departmentType: ''
  }
}
export default {
  name: "typeList",
  components: {
    // products,
  },
  data() {
    return {
      tooltipContent: "提示：只能上传jpg/png文件，且不超过100kb，图片尺寸1:1",
      dataLoding: false,
      departmentName: "",
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalCount: 0, // 总记录数（需要从后端获取）
      srcList: [],
      imgUrl: "", //默认网图
      // showViewer: false, // 显示查看器、
      importFiles: [],
      options: [],
      arry: [
        { value: '1', label: '项目服务部门' },
        { value: '2', label: '职能部门' },

      ],
      parentId: '',
      // 弹窗
      headers: { token: this.$store.state.token },
      addApi: true, //新增分类
      twoAdd: true, //二级分类新增
      twoEdit: true, //二级分类修改
      addCategoryId: null,
      categoryIdOne: null,
      categoryIdTwo: null,
      dialogTitle: "新增", // 弹窗标题
      dialogVisible: false, // 弹窗显隐
      addProductDialog: false, // 弹窗显隐
      ruleForm: createRuleForm(),
      rules: {
        departmentName: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
        departmentHead: [{ required: true, message: "请输入部门负责人", trigger: "blur" }],
        departmentType: [{ required: true, message: "请输入项目类型", trigger: "blur" }],
      },
    }
  },
  created() {
    this.getCategoryList()
    this.selectParentDepartment()
  },
  methods: {
    // 获取上级下拉框
    selectParentDepartment() {
      this.$axios.get(this.$api.selectParentDepartment, {
        params: {}
      }).then(res => {
        this.options = res.result
      })
    },
    getCategoryList() {
      this.dataLoding = true
      this.$axios.get(this.$api.departmentInfoSelect, {
        params: {
          page: this.currentPage,
          pageSize: this.pageSize,
          departmentName: this.departmentName || null,
        },
      }).then(res => {
        this.dataLoding = false
        this.tableData = res.result
        this.totalCount = res.result.totalCount
      })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    async submitForm(formName) {
      try {
        // 校验表单
        await new Promise((resolve, reject) => {
          this.$refs[formName].validate(valid => {
            if (!valid) {
              this.$message.error("请检查内容是否有漏填！")
            } else {
              resolve() // 校验成功，解决Promise
            }
          })
        })
        // console.log(this.categoryIdOne);
        let params = {}
        let url = ""
        let msg = ""
        let method = ""
        if (this.addApi) {
          // 新增
          url = this.$api.departmentInfoInsert
          msg = "新增"
          method = "post"
          if (!this.twoAdd) {
            // 新增一级
            params.departmentName = this.ruleForm.departmentName
            params.departmentHead = this.ruleForm.departmentHead
            params.departmentType = this.ruleForm.departmentType
            // params.parentId = this.ruleForm.parentId
          } else {
            // 新增二级
            params.departmentName = this.ruleForm.departmentName
            params.departmentHead = this.ruleForm.departmentHead
            params.parentId = this.ruleForm.departmentId
            params.departmentType = this.ruleForm.departmentType
            // params.departmentId = this.ruleForm.departmentId
          }
        } else {
          // 编辑
          url = this.$api.departmentInfoUpdate
          msg = "修改"
          method = "post"
          if (!this.twoEdit) {
            // 修改一级
            params.departmentName = this.ruleForm.departmentName
            params.departmentHead = this.ruleForm.departmentHead
            params.departmentId = this.ruleForm.departmentId
            params.parentId = this.ruleForm.parentId
            params.departmentType = this.ruleForm.departmentType
          } else {
            // 修改二级
            params.departmentName = this.ruleForm.departmentName
            params.departmentHead = this.ruleForm.departmentHead
            params.departmentId = this.ruleForm.aa
            params.parentId = this.ruleForm.parentId
            params.departmentType = this.ruleForm.departmentType
          }
        }
        this.submitLoding = true
        this.$axios[method](url, params)
          .then(res => {
            this.submitLoding = false
            if (res.code === 100) {
              this.handleCloseDialog()
              this.getCategoryList()
              this.selectParentDepartment()
              this.$message.success(`${msg}成功`)
            } else {
              this.$message.error(`${msg}失败`)
            }
          })
          .catch(err => {
            this.$message.error(err.desc)
          })
      } catch (err) {
        console.log(err)
      }
    },
    handleEdit(item) {
      // this.categoryIdOne = item.categoryId
      let { departmentId, parentId, departmentName, departmentHead, departmentType } = item
      if (parentId == 0) {
        // console.log(item);
        this.twoEdit = false
        this.dialogTitle = "修改"
        this.ruleForm = {
          parentId: parentId,
          departmentName: departmentName,
          departmentHead: departmentHead,
          departmentId,
          departmentType: departmentType,
        }
      } else {
        this.twoEdit = true
        this.dialogTitle = "修改二级"
        this.ruleForm = {
          parentId: parentId,
          departmentName: departmentName,
          departmentHead: departmentHead,
          departmentId: parentId,
          departmentType: departmentType,
          aa:departmentId
        }
        // console.log(item);

      }
      this.addApi = false
      this.dialogVisible = true
    },
    handleAdd() {
      this.ruleForm = createRuleForm()
      this.addApi = true
      this.twoAdd = false
      this.twoEdit = false
      this.dialogTitle = "新增"
      this.dialogVisible = true
    },
    handleAddTwo(item) {
      // console.log(item);
      let { departmentId, parentId, departmentName, departmentHead, departmentType } = item
      this.ruleForm = {
        // departmentName: departmentName,
        parentId: parentId,
        departmentType: departmentType,
        departmentId: departmentId,
      }
      this.addApi = true
      this.twoAdd = true
      this.twoEdit = true
      this.dialogTitle = "新增二级"
      this.dialogVisible = true
    },
    handleUpdateProduct(row) {
      this.addCategoryId = row.categoryId
      this.addProductDialog = true
    },
    closeAddProductDialog() {
      this.addProductDialog = false
    },
    handleCloseDialog() {
      this.$refs["ruleForm"].resetFields()
      this.categoryIdOne = null
      this.categoryIdTwo = null
      this.dialogVisible = false
      this.ruleForm = createRuleForm()
      this.dialogTitle = "新增"
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.pageSize = e
      this.onScreenData()
    },
    // 换页
    handleCurrentChange() {
      this.page += 1
      this.tableData = []
      this.getCategoryList()
    },
    // 筛选
    onScreenData() {
      this.currentPage = 1
      this.tableData = []
      this.getCategoryList()
    },
    // 删除
    handleDelete(item) {
      this.$confirm("确定删除该部门？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          return this.$axios.post(`${this.$api.departmentInfoDelete}/${item.departmentId}`)
        })
        .then(res => {
          if (res.code == 100) {
            this.$message.success("删除成功")
            this.getCategoryList()
          } else {
            this.$message.error("删除失败")
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 图片上传
    handleSuccess(res) {
      if (res.code == 100) {
        this.ruleForm.picUrl = res.result.fileUrl
        this.$message({
          message: "上传成功！",
          type: "success",
        })
      } else {
        this.$message({ showClose: true, message: res.desc, type: "error" })
      }
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png"
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!")
      }
      return isJPG && isLt5M
    },
    // 点击按钮预览图片
    handleCommand(row) {
      if (this.srcList.length > 0) {
        this.srcList = []
      }
      if (row && row.picUrl) {
        this.srcList = [row.picUrl]
      }
      this.$refs.preview.clickHandler()
    },
    // 关闭查看器
    // closeViewer() {
    //   this.showViewer = false
    // },
    cancellist() {
      this.addProductDialog = false
    },
    handleSubmit(e) {
      this.loading = true
      let arr = e.map(item => item.productSupplierId)
      this.$axios
        .post(this.$api.updateProductCategory, {
          categoryId: this.addCategoryId,
          productIdList: arr,
        })
        .then(res => {
          if (res.code == 100) {
            this.$message.success("添加成功")
            this.addProductDialog = false
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.search-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px #bfbebe dashed;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.demo_ruleForm {
  .el-row {
    width: 100% !important;
  }
}
</style>
